import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueAWN from 'vue-awesome-notifications';
import App from './App.vue';
import router from './router';
import titleMixin from './mixins/titleMixin';

Vue.config.productionTip = false;
Vue.mixin(titleMixin);

// Enable i18n
Vue.use(VueI18n);

if (!localStorage.getItem('appLang')) {
  localStorage.setItem('appLang', 'nor');
}

const getUserLang = localStorage.getItem('appLang');

const i18n = new VueI18n({
  locale: getUserLang,
});

// Enable Notifications
Vue.use(VueAWN, { enabled: false });

Vue.filter('toCurrency', (value) => {
  if (typeof value !== 'number') {
    return value;
  }

  const formatter = new Intl.NumberFormat('no', {
    style: 'currency',
    currency: 'NOK',
    minimumFractionDigits: 2,
  });

  return formatter.format(value);
});

Vue.filter('toFixed', (value) => {
  if (typeof value !== 'number') {
    return value;
  }

  return value.toFixed(2);
});

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
